module.exports = __webpack_public_path__ + "static/gallery29-732f3efa096b5efabe204ad8c93f993c.jpg";